import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useFileReader } from './hooks';
import { setDeleteMessage } from '../../actions/sendMessage';
import { retrySendMessageById } from '../../actions/sendMessage/retrySendMessageById';
import { ChatImageDraft } from '../../components/ChatImageDraft';
import { currentOpenChatIDSelector } from '../../selectors';
import { ERequestApiStatus } from '../../types/appState';
import { TOutcomingStatus } from '../../types/messages';
import { useApplicationContext } from '../../utils/applicationContext';
import { ICancellationToken } from '../../utils/cancelationToken';

interface IChatImageProps {
  file: File;
  messageId: string;
  cancellationToken: ICancellationToken;
  messageStatus: TOutcomingStatus;
  isGalleryItem?: boolean;
}

export const ChatImageDraftContainer: React.FC<IChatImageProps> = ({
  file,
  messageId,
  cancellationToken,
  isGalleryItem,
  messageStatus,
}) => {
  const chatId = useSelector(currentOpenChatIDSelector);
  const { custom } = useApplicationContext();

  const dispatch = useDispatch();

  const { image, isLoading, isError } = useFileReader(file);

  const handleCancel = () => {
    if (!chatId) {
      return;
    }

    cancellationToken.cancel();
    dispatch(setDeleteMessage({ chatId, messageId, messagesMap: custom.messagesMap }));
  };

  const handleReload = React.useCallback(() => {
    dispatch(retrySendMessageById(chatId as string, messageId));
  }, [chatId, dispatch, messageId]);

  return (
    <ChatImageDraft
      image={image}
      isError={isError}
      withCancel={messageStatus === ERequestApiStatus.Pending}
      onCancel={handleCancel}
      withReload={messageStatus === ERequestApiStatus.Failed}
      onReload={handleReload}
      isLoading={isLoading || messageStatus === ERequestApiStatus.Pending}
      isGalleryItem={isGalleryItem}
    />
  );
};
